/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Image, Icon, Flag, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  liveListAction, liveListMatrixAction, configAction,
  oscilloscopeAction, barGraphAction, tsExpertAction,
  opticFiberAction, OpticFiberLogAction, logAction
} from "../../actions/changeActiveItemActions";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();
class BootstrapMenuBar extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      dropdownTitle: Strings.PHYS_MEDIUM,
      oscilloscopeStyle: { display: "block" },
      olmStyle: { display: "none" },
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY),
      language: UtilsInstance.getLanguageStringFromKey(
        Constants,
        Strings),
      isUpdatingLanguageDimmerActive: false
    };
  }

  handleSelect = (eventKey) => {
    switch (eventKey) {
      case "/":
        this.props.onChangeTSExpert();
        this.props.history.push("/");
        break;
      case "/live-list":
        this.props.onChangeLiveList();
        this.props.history.push("/live-list");
        break;
      case "/live-list-matrix":
        this.props.onChangeLiveListMatrix();
        this.props.history.push("/live-list-matrix");
        break;
      case "/oscilloscope":
        this.props.onChangeOscilloscope();
        this.props.history.push("/oscilloscope");
        break;
      case "/bar-graph":
        this.props.onChangeBarGraph();
        this.props.history.push("/bar-graph");
        break;
      case "/optic-fiber":
        this.props.onChangeOpticFiber();
        this.props.history.push("/optic-fiber");
        break;
      case "/optic-fiber-log":
        this.props.onChangeOpticFiberLog();
        this.props.history.push("/optic-fiber-log");
        break;
      case "/log":
        this.props.onChangeLog();
        this.props.history.push("/log");
        break;
      case "/config":
        this.props.onChangeConfig();
        this.props.history.push("/login-handler");
        break;
      default:
        break;
    }
  }

  handleLanguageChange = (lang) => {
    this.sendLanguageData(lang);
  }

  sendLanguageData = (lang) => {
    this.setState({ isUpdatingLanguageDimmerActive: true }, () => {

      fetch(Constants.REQUEST_IP_ADDRESS + "language_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ language: lang })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          localStorage.setItem(Constants.LOCAL_STORAGE_KEY, lang);
          window.location.reload();
        })
        .catch((error) => {
          alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON_DP + error);
        })
        .finally(this.setState({ isUpdatingLanguageDimmerActive: false }));
    });
  }

  getOpticFiberNav = (isFiberProcessOn) => {
    if (!isFiberProcessOn) {
      return null;
    }

    return (
      <Nav pullLeft bsStyle="pills" onSelect={k => this.handleDropdownSelect(k)} activeKey={this.props.active}>
        <NavDropdown id="nav-drop" style={fontStyle} title={this.state.dropdownTitle}>
          <MenuItem eventKey="/drop-mon">{Strings.PHYS_MEDIUM}</MenuItem>
          <MenuItem eventKey="/drop-opticFiber">{Strings.OPTIC_FIBER}</MenuItem>
        </NavDropdown>
      </Nav>
    );
  }

  handleDropdownSelect = (eventKey) => {
    if (eventKey === "/drop-mon") {
      this.setState({
        dropdownTitle: Strings.PHYS_MEDIUM,
        oscilloscopeStyle: {
          display: "block"
        },
        olmStyle: {
          display: "none"
        }
      }, () => {
        this.handleSelect("/live-list");
      });
    }
    else if (eventKey === "/drop-opticFiber") {
      this.setState({
        dropdownTitle: Strings.OPTIC_FIBER,
        oscilloscopeStyle: {
          display: "none"
        },
        olmStyle: {
          display: "block"
        }
      }, () => {
        this.handleSelect("/optic-fiber");
      });
    }
  }

  setMenuBarCurrentState = () => {
    const currentPath = this.props.history.location.pathname;
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (isFiberProcessOn) {
      if (currentPath.includes("/optic-fiber")) {
        this.setState({
          dropdownTitle: Strings.OPTIC_FIBER,
          oscilloscopeStyle: { display: "none" },
          olmStyle: { display: "block" }
        });
      } else {
        this.setState({
          dropdownTitle: Strings.PHYS_MEDIUM,
          oscilloscopeStyle: { display: "block" },
          olmStyle: { display: "none" }
        });
      }
    } else {
      this.setState({
        dropdownTitle: Strings.PHYS_MEDIUM,
        oscilloscopeStyle: { display: "block" },
        olmStyle: { display: "none" }
      });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.setMenuBarCurrentState();
  }

  render() {
    let activePage = { "activeItem": "/" + this.props.location.pathname.split("/")[1] };
    const isFiberProcessOn = sessionStorage.getItem("isFiberProcessOn") === "true";

    if (activePage.activeItem === "/login"
      || activePage.activeItem === "/login-handler"
      || activePage.activeItem === "/report"
      || activePage.activeItem === "/change-login"
      || activePage.activeItem === "/tags"
      || activePage.activeItem === "/segment-devices"
      || activePage.activeItem === "/wlan-config"
      || activePage.activeItem === "/ethernet-config"
      || activePage.activeItem === "/active-channels"
      || activePage.activeItem === "/ts-expert-config"
      || activePage.activeItem === "/optic-fiber-config") {
      activePage.activeItem = "/config";
    }

    const { activeItem } = activePage;

    return (
      <>
        <Navbar fluid defaultExpanded inverse collapseOnSelect style={menuStyle}>
          <Navbar.Header>
            <Navbar.Brand>
              <Image style={noBorderStyle} src="./logo.png" alt="TS Scope DP Logo" href="/" size="tiny" />
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>
            <Nav pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/"
                active={activeItem === "/"}>
                {Strings.TS_EXPERT}
              </NavItem>
            </Nav>

            {this.getOpticFiberNav(isFiberProcessOn)}

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/live-list"
                active={activeItem === "/live-list"}>
                {Strings.LIVE_LIST}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/live-list-matrix"
                active={activeItem === "/live-list-matrix"}>
                {Strings.LIVE_LIST_MATRIX}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/oscilloscope"
                active={activeItem === "/oscilloscope"}>
                {Strings.OSCILLOSCOPE}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey="/bar-graph"
                active={activeItem === "/bar-graph"}>
                {Strings.BAR_GRAPH}
              </NavItem>
            </Nav>

            <Nav style={this.state.oscilloscopeStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
              <NavItem
                style={fontStyle}
                eventKey='/log'
                active={activeItem === "/log"}>
                Log
              </NavItem>
            </Nav>

            {isFiberProcessOn && (
              <Nav style={this.state.olmStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
                <NavItem
                  style={fontStyle}
                  eventKey="/optic-fiber"
                  active={activeItem === "/optic-fiber"}>
                  {Strings.OPTIC_FIBER}
                </NavItem>
              </Nav>
            )}

            {isFiberProcessOn && (
              <Nav style={this.state.olmStyle} pullLeft bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>
                <NavItem
                  style={fontStyle}
                  eventKey="/optic-fiber-log"
                  active={activeItem === "/optic-fiber-log"}>
                  {Strings.LOG}
                </NavItem>
              </Nav>
            )}

            <Nav pullRight bsStyle="pills" onSelect={k => this.handleSelect(k)} activeKey={this.props.active}>

              <NavDropdown
                role="menuitem"
                id="language-dropdown"
                eventKey={this.state.languageKey}
                title={this.state.language}
                onSelect={lang => this.handleLanguageChange(lang)}>

                <MenuItem
                  eventKey="pt">
                  <Flag name="br" />
                  {Strings.PORTUGUESE}
                </MenuItem>

                <MenuItem
                  eventKey="en">
                  <Flag name="us" />
                  {Strings.ENGLISH}
                </MenuItem>

                <MenuItem
                  eventKey="es">
                  <Flag name="es" />
                  {Strings.SPANISH}
                </MenuItem>

                {/* <MenuItem
                  eventKey="de">
                  <Flag name="de" />
                  {Strings.GERMAN}
                </MenuItem> */}

              </NavDropdown>

              <NavItem
                style={fontStyle}
                eventKey='/config'
                active={activeItem === "/config"}>
                <Icon name="cog" />
                {Strings.CONFIG}
              </NavItem>
            </Nav>

          </Navbar.Collapse>

        </Navbar>

        <Dimmer page active={this.state.isUpdatingLanguageDimmerActive} >
          <Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader>
        </Dimmer>
      </>
    );
  }
}

const mapStateToProps = state => ({
  active: state.activeMenuItem
});

const mapActionsToProps = {
  onChangeTSExpert: tsExpertAction,
  onChangeLiveList: liveListAction,
  onChangeLiveListMatrix: liveListMatrixAction,
  onChangeOscilloscope: oscilloscopeAction,
  onChangeBarGraph: barGraphAction,
  onChangeOpticFiber: opticFiberAction,
  onChangeOpticFiberLog: OpticFiberLogAction,
  onChangeLog: logAction,
  onChangeConfig: configAction
};

const menuStyle = {
  backgroundColor: "#262626",
  padding: "8pt",
  borderRadius: "0pt",
  borderWidth: 0
};

const fontStyle = {
  // fonte mais em negrito
  fontSize: "12pt",
};

const noBorderStyle = {
  marginTop: "-4pt"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));
